import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'limitString',
})
export class LimitStringPipe implements PipeTransform {
  transform(value: string, limit: number = 50, trail: string = '...'): string {
    if (!value) return '';

    if (value.length <= limit) {
      return value;
    }

    return value.substring(0, limit) + trail;
  }
}
